import type { TKey } from "../../i18n/translations";
import type { StatsConfig, Theme } from "../types";
import { LiveDot } from "./LiveDot";

export function Footer({
  cfg,
  theme,
  updatedAt,
  isFetching,
  t,
}: {
  cfg: StatsConfig;
  theme: Theme;
  updatedAt: number;
  isFetching: boolean;
  t: (k: TKey) => string;
}) {
  if (cfg.brand === "none") return null;
  const muted = theme === "dark" ? "text-white/45" : "text-ink-400";
  return (
    <footer className={"flex items-center gap-2 px-4 sm:px-5 py-2 text-[10.5px] tracking-wide " + muted}>
      <LiveDot pulse={isFetching} />
      {cfg.brand === "full" && (
        <>
          <span className="font-medium" style={{ color: "var(--lm-fg)", opacity: 0.85 }}>
            {t("statSubtitle")}
          </span>
          <span className="opacity-60">·</span>
        </>
      )}
      <span>{t("poweredBy")}</span>
      {updatedAt > 0 && (
        <>
          <span className="opacity-60">·</span>
          <span>
            {t("statUpdated")} {formatTime(updatedAt)}
          </span>
        </>
      )}
    </footer>
  );
}

function formatTime(ts: number): string {
  try {
    return new Date(ts).toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
}
